import Network from 'infrastructure/js/modules/network';
import * as formActionsHelper from '../../Forms/formActionsHelper';
import { api as messageDialogApi } from '../../MessageDialog/messageDialogActions.js';
import * as materialsService from '../../../services/Materials/materialsService.js';
import { formsNames } from '../../../enums/formsNames';
import { getResponseValidationDetails } from 'infrastructure/js/components/Form/formHelper';
import uniqBy from 'lodash-es/uniqBy';

const config = {
  getSubmitMethod: () => null, //set null when override the formActionsHelper's submit() method
};

export const actionTypes = {
  ...formActionsHelper.getActionTypes(formsNames.CREATE_MATERIAL_TYPE_FORM),
};

const actions = {
  ...formActionsHelper.getActions(formsNames.CREATE_MATERIAL_TYPE_FORM),
};

export let api = {
  ...formActionsHelper.getApiActions(actions, config),


  fetchFormItem(dispatch, getState) {
    return function (materialTypeId) {
      dispatch(actions.setBusy(true));

      return materialsService.getMaterial(materialTypeId).then(response => {
        dispatch(actions.setBusy(false));

        if (!Network.isResponseValid(response)) {
          console.error('fetch material failed', response);
          messageDialogApi.responseError(dispatch, getState)(response);
          return null;
        }

        return response.data ?? null;
      })
    }
  },

  fetchFormData(dispatch, getState) {
    return function () {
      dispatch(actions.setBusy(true));

      return materialsService.fetchAllMaterials().then((response) => {
        if (!Network.isResponseValid(response)) {
          console.error('Fetch materials failed', response);
          messageDialogApi.responseError(dispatch, getState)(response);
          return {success: false};
        }

        let materials = response.dataList.filter((obj) => {return !!obj.materialName});
        materials = uniqBy(materials, 'materialName');

        let formData = {
          materials: materials.map((obj) => {return {value: obj.id, label: obj.materialName, data: obj}}),
        };

        dispatch(actions.fetchFormDataReady(formData));
        dispatch(actions.setBusy(false));

        return { success: true };
      });
    };
  },


  submit(dispatch, getState) {
    return function (data, isEditMode, reloadParentComponent) {
      dispatch(actions.setBusy(true));

      let method = isEditMode ? materialsService.editMaterial : materialsService.createMaterial;

      method(data).then((response) => {
        dispatch(actions.setBusy(false));

        let validations = getResponseValidationDetails(response);
        if (validations) {
          dispatch(actions.setValidationWarningsData(validations));
          return { success: false };
        }

        if (!Network.isResponseValid(response)) {
          console.error('Create/Edit material type failed', response);
          messageDialogApi.responseError(dispatch, getState)(response);
          return { success: false };
        }

        if (reloadParentComponent) {
          reloadParentComponent();
        }

        return { success: true };
      });
    };
  },

};

export let jsxActions = {
  ...formActionsHelper.getJsxActions(api),

  fetchFormItem(materialTypeId) {
    return function (dispatch, getState) {
      return api.fetchFormItem(dispatch, getState)(materialTypeId);
    };
  },

  submit(data, isEditMode, reloadParentComponent) {
    return function (dispatch, getState) {
      return api.submit(dispatch, getState)(data, isEditMode, reloadParentComponent);
    };
  },

};

/////////////////////////////////////////////////////////////////////////
// PRIVATE HELPERS

